<template>    
<section>

    <div class="portal">

      <div class="portal__block">
        <div class="portal__tools">
        <input type="file" class="inputfile" ref="fileInput" @change="onFilePicked" accept="image/*"/>
          <div class="portal__button" @click="uploadNewImage()">upload {{filename}}</div>          

        </div>
        <div class="portal__tools-spacer"></div>
        <div class="portal__image-container">
          <div class="portal__image-parent" v-for="(display, idx) in media" :key="idx">
            <img :src="display.src" alt="" >
          </div>
        </div>
          
      </div>

      <div class="portal__add">
        <img src="/static/plus-01.svg" alt="">
        <div>add images</div>
      </div>
      
    </div>
    </section>
    </template>

    <script>
import { page } from 'vue-analytics'
import { firestore } from '../main'
import firebase from 'firebase'


export default {
  data () {
    return {
      tools: false,
      media: {},
      imageUrl: '',
      image: '',
      filename: ''
    }
  },
  components: {
  },
  firestore() {
    return { media: firestore.collection('media').orderBy('createdAt')}
  },
  methods: {
    uploadNewImage (user, type) {
      if (this.image != null) {
        let filename = this.filename
        let newUrl = this.image
        const createdAt = new Date()

        firebase.storage().ref('media/' + filename).put(newUrl)
          .then(data => {
            firebase.storage().ref('media/' + filename).getDownloadURL()
              .then((url) => {
                firestore.collection('media').add({src: url, createdAt: createdAt})
                .then((data) => {
                  firestore.collection('media').doc(data.id).update({id: data.id})
                })
              })
              .catch((error) => {
                console.error(error)
              })
          })
      }
    },
    onFilePicked (event) {
      const files = event.target.files
      let filename = files[0].name
      this.filename = filename

      if (filename.lastIndexOf('.') <= 0) {
        return alert('Please add a valid file type.')
      }

      const fileReader = new FileReader
      fileReader.addEventListener('load', () => {
        this.imageUrl = fileReader.result
      })

      fileReader.readAsDataURL(files[0])
      this.image = files[0]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Media.vue